// extracted by mini-css-extract-plugin
module.exports = {"button":"QuestionTable_button__bg8kt","table":"QuestionTable_table__3GEeu","input":"QuestionTable_input__32Cpn","questions":"QuestionTable_questions__2cTRn"};